type CheckboxGroupFieldProps = {
  label: string;
  name: string;
  options: string[];
  values: string[];
  onChange: (name: string, value: string, checked: boolean) => void;
};

export const CheckboxGroupField = ({
  label,
  name,
  options,
  values,
  onChange,
}: CheckboxGroupFieldProps) => {
  return (
    <div>
      <label className="block text-[16px] md:text-[17px] font-medium text-[#111827] mb-2">
        {label} <span className="text-red-500">*</span>
      </label>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {options.map((option) => (
          <label key={option} className="flex items-start gap-2 cursor-pointer">
            <input
              type="checkbox"
              name={name}
              value={option}
              checked={values.includes(option)}
              onChange={(e) => onChange(name, option, e.target.checked)}
              className="mt-[2px] w-4 h-4 text-[#026857] border-gray-300 rounded focus:ring-[#026857]"
            />
            <span className="text-[16px] leading-5 text-[#111827]">{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

